import { useSelector } from 'react-redux';
import CringeShell from './CringeShell';

// thankyou.php: "Your score is <total_score> out of 15 in <time> minutes."
export default function CringeThankyou() {
  const game = useSelector((s) => s.cringe.game);
  return (
    <CringeShell bg="bg_desk.png" bgMob="bg_mob.png" stage="thankyou" className="cr-thankyou">
      <div className="cr-thankyou-inner">
        <img src="/cringe/img/thankyou.gif" alt="Thank you" />
        <div className="cr-thankyou-score">
          Your score is {game?.totalScore ?? 0} out of 15 in {game?.time || '00:00'} minutes.
        </div>
      </div>
    </CringeShell>
  );
}
